import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'peca-shipping-failed',
  templateUrl: './shipping-failed.component.html',
  styleUrl: './shipping-failed.component.scss',
  imports: [],
})
export class ShippingFailedComponent {
  @Input()
  failure?: { title: string; description: string };

  @Input()
  title?: string;

  @Input()
  description?: string;

  @Output()
  retry = new EventEmitter<void>();

  onClickRetry() {
    this.retry.emit();
  }
}
